import { render, staticRenderFns } from "./ExercisePracticeCard.vue?vue&type=template&id=35c80778&scoped=true"
import script from "./ExercisePracticeCard.vue?vue&type=script&lang=js"
export * from "./ExercisePracticeCard.vue?vue&type=script&lang=js"
import style0 from "./ExercisePracticeCard.vue?vue&type=style&index=0&id=35c80778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c80778",
  null
  
)

export default component.exports